<template>
  <v-card
    width="600"
    style="max-height: 800px; overflow-y: auto;"
  >
    <v-system-bar
      color="deep-purple darken-4"
      dark
    >
    </v-system-bar>
    <v-toolbar
      color="deep-purple accent-4"
      cards
      dark
      flat
    >
      <v-icon dark>collections</v-icon>
      <v-toolbar-title>Retrieved Images</v-toolbar-title>
    </v-toolbar>

    <v-layout
      align-end
      fill-height
      pl-5
      pr-5
      mt-5
      black--text
      v-show="images.length == 0 & !loadingImages"
    >
      <div class="title font-weight-light">
        Nothing to show, click submit to get news photos.
      </div>
    </v-layout>

    <div
      class="pa-5 text-xs-center"
      v-if="loadingImages"
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="deep-purple"
        indeterminate
        class="text-xs-center"
      ></v-progress-circular>
    </div>
    <v-container
      v-else
      fluid
      grid-list-sm
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          v-for="(item, key) in images"
          :key="key"
          xs4
        >
          <img
            :src="getImage(item)"
            class="image"
            alt="img"
            width="100%"
            height="100%"
            @click="openImage(item)"
          >
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      v-model="dialog"
      max-width="800px"
    >
      <v-card @click="dialog=false">
        <v-card-media
          :src="getImage(dialogImage.img_path)"
          height="400px"
          contain
        >
        </v-card-media>
        <!-- <v-card-media
          src="https://cdn.vuetifyjs.com/images/cards/desert.jpg"
          height="200px"
        ></v-card-media> -->
        <v-card-title primary-title>
          <div>
            <span class="grey--text">{{dialogImage.caption}}</span><br><br>
            <h3 class="headline mb-0">{{dialogImage.title}}</h3>
            <h2 class="subheading mb-0">{{dialogImage.lead}}</h2>
          </div>
        </v-card-title>
        <v-card-text>
          <span v-html="dialogImage.article"></span>
        </v-card-text>
        <!-- <v-card-text>
            Caption-abstract: <span class="grey--text">{{dialogImage.caption}}</span><br><br>
            Description: <span class="grey--text">{{dialogImage.description}}</span><br><br>
            Headline: <span class="grey--text">{{dialogImage.headline}}</span><br><br>
            Keywords: <span class="grey--text">{{dialogImage.keyword}}</span><br><br>
        </v-card-text> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="deep-purple"
            flat
            @click.stop="dialog=false"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  data() {
    return {
      dialog: false,
      dialogImage: {
        img_path: '',
        title: '',
        lead: '',
        article: '',
        caption: ''
      }
    }
  },
  computed: {
    ...mapGetters(['images', 'loadingImages'])
  },
  methods: {
    openImage(imageName) {
      this.dialog = true;
      this.dialogImage.img_path = imageName;
      const filename = imageName.split(/[\\/]/).pop();
      const lang = imageName.substring(0, 2);
      axios.get('/metadata/' + filename + '/' + lang).then(response => {
        this.dialogImage.article = response.data['body']
        this.dialogImage.lead = response.data['lead']
        this.dialogImage.caption = response.data['caption']
        this.dialogImage.title = response.data['headline']
      })
    },
    getImage(imageName) {
      return process.env.VUE_APP_IMAGE_SERVER + '/images/' + imageName;
    }
  }
}
</script>
